rdefine('app/events/month',['backbone'],function(Backbone) {

    var monthRowDay = Backbone.Ribs.View.extend({
        tagName: 'div',
        className: 'event-month-day',
        bindings: {
            span: {
                text: 'model.value'
            },
            el: {
                classes:{
                    active:'model.active',
                    disabled:'model.disabled'
                }
            }
        },
        events: {
            "click": "onClick"
        },
        imodel:null,
        initialize: function () {
            this.$el.html('<span></span>');
            if(this.model.get("value")==='') {
                return;
            }
            this.imodel = this.collection.dates.getormake(this.model.get("date"));

            if(this.imodel) {
                this.imodel.on("change", _.bind(function () {
                    this.model.set('active', this.imodel.get('active'));
                }, this));
            }
        },
        onClick: function () {
            if(this.model.get('disabled')) {
                return false;
            }
            if(this.model.get("active")) {
                this.collection.dates.disable(this.model.get('date'));
                this.model.set('active',false);
            }else{
                this.collection.dates.enable(this.model.get('date'));
                this.model.set('active',true);
            }


        }
    });

    var monthRow = Backbone.Ribs.View.extend({
        tagName:'div',
        className:'event-month-row',
        days:null,
        bindings:{
            el:{
                collection:{
                    col:'days',
                    view:monthRowDay
                }
            }
        },
        initialize:function(){
            this.days = new Backbone.Ribs.Collection(this.model.get("days"), {model:Backbone.Ribs.Model});
            this.days.dates = this.collection.dates;

            this.model.on("change:days", _.bind(function(){
                this.days.reset(this.model.get("days"));
            },this));
        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'event-month',
        days:0,
        begin:0,
        date:null,
        bindings:{
            h3:{
                text:'model.title'
            },
            '.events-month-rows':{
                collection:{
                    col:'weeks',
                    view:monthRow
                }
            }
        },
        weeeks:null,
        dates:null,
        initialize:function(options) {
            this.dates = this.collection.dates;

            this.$el.html('<h3></h3><div class="events-month-rows"></div>');
            this.weeks = new Backbone.Ribs.Collection();
            this.collection.on("updates",_.bind(this.reloadMonth,this));
            this.date = moment(this.model.get('month'),'YYYY-MM');
            this.days = this.date.daysInMonth();
            this.begin = this.date.startOf('month').day();
            var t = [];
            var cday = 1;
            var now = moment().startOf('day');
            for(var week = 0;week<5;week++) {
                if(typeof t[week] === 'undefined') {
                    t[week] = {days:[]};
                }
                if(week === 0) {
                    for(var day=0;day<this.begin;day++) {
                        t[week].days.push({value:'',active:false,disabled:true});
                    }
                    for(var day=this.begin;day<7;day++, cday++) {
                        t[week].days.push({value:cday,date:this.date.date(cday).format('YYYY-MM-DD'),active:this.dates.isPresentedAndActive(this.date.date(cday).format('YYYY-MM-DD')), disabled:this.date.date(cday).isBefore(now)});
                    }
                }else{
                    for(var day = 0;day<7;day++, cday++) {
                        if(cday>this.days) {
                            t[week].days.push({value:'',active:false,disabled:true});
                            continue;
                        }
                        t[week].days.push({value:cday,date:this.date.date(cday).format('YYYY-MM-DD'),active:this.dates.isPresentedAndActive(this.date.date(cday).format('YYYY-MM-DD')), disabled:this.date.date(cday).isBefore(now)});
                    }
                }
            }

            this.weeks.dates = this.dates;
            this.weeks.reset(t);
        },
        reloadMonth: function() {
            this.weeks.map(_.bind(function(week) {
                var changed = false;
                var a = _.reduce(week.attributes.days, _.bind(function(a, day) {
                    var nactive = this.dates.isPresentedAndActive(day.date);
                    if(nactive!==day.active) {
                        changed = true;
                    }
                    day.active = nactive;
                    a.push(day);
                    return a;
                },this), []);
                if(changed) {
                    week.set('days',a).trigger("change:days");
                }
            },this));
        }
    });
});